var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElementUtils, CustomElement, Watch, PropertyConverters, PacemEventTarget, Components, Utils, Logging } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
export var StickyHeaderVisibility;
(function (StickyHeaderVisibility) {
    StickyHeaderVisibility["Persistent"] = "persistent";
    StickyHeaderVisibility["QuickReturn"] = "quickreturn";
})(StickyHeaderVisibility || (StickyHeaderVisibility = {}));
let PacemStickyHeaderElement = class PacemStickyHeaderElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this.#previousOffset = { left: 0, top: 0 };
        this._scrollHandler = (evt) => {
            this.offset = evt.detail;
        };
    }
    #scroller;
    #previousOffset;
    #id;
    #shell;
    _ensureScrollAwareElement() {
        if (Utils.isNull(this.#scroller)) {
            const scroller = this.#scroller = new Components.PacemScrollAwareElement();
            this.log(Logging.LogLevel.Debug, 'creating scroll aware ' + this.#id);
            const shell = this.#shell = CustomElementUtils.findAncestorShell(this);
            shell.appendChild(scroller);
            scroller.dataset["target"] = this.#id;
            scroller.addEventListener(Components.ScrollEventName, this._scrollHandler, false);
        }
        this.#scroller.disabled = this.disabled;
    }
    _manageOffsetChange(offset = this.offset) {
        if (this.disabled) {
            return;
        }
        const visibility = this.visibility || StickyHeaderVisibility.Persistent, lastTop = this.#previousOffset.top, top = offset.top, threshold = this.threshold || 0, shell = this.#shell;
        if (lastTop <= threshold && top > threshold) {
            Utils.removeClass(shell, 'sticky-header-top');
            Utils.addClass(shell, 'sticky-header-scroll');
            // get into wavy behavior and aspect
            if (visibility === StickyHeaderVisibility.QuickReturn) {
                Utils.addClass(shell, 'sticky-header-fade');
                this.visible = false;
            }
        }
        else if (lastTop > threshold && top <= threshold) {
            // back to steady form
            Utils.removeClass(shell, 'sticky-header-fade');
            Utils.removeClass(shell, 'sticky-header-scroll');
            Utils.addClass(shell, 'sticky-header-top');
        }
        else if (lastTop > threshold && top > threshold && lastTop > top) {
            // scrolling up, show
            this.visible = true;
            Utils.removeClass(shell, 'sticky-header-fade');
        }
        else if (lastTop > threshold && top > threshold && lastTop < top && visibility == StickyHeaderVisibility.QuickReturn) {
            // keep scrolling down with quick return, hide
            Utils.addClass(shell, 'sticky-header-fade');
        }
        this.#previousOffset = offset;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'offset':
                this._manageOffsetChange(val);
                break;
            case 'disabled':
                this._ensureScrollAwareElement();
                break;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this.#id = this.id || 'sticky-' + Utils.uniqueCode();
        this._ensureScrollAwareElement();
    }
    disconnectedCallback() {
        const scroller = this.#scroller, shell = this.#shell;
        if (!Utils.isNull(scroller)) {
            this.log(Logging.LogLevel.Debug, 'disposing scroll aware ' + this.#id);
            scroller.removeEventListener(Components.ScrollEventName, this._scrollHandler, false);
            scroller.remove();
            this.#scroller = undefined;
            Utils.removeClass(shell, 'sticky-header-fade');
            Utils.removeClass(shell, 'sticky-header-top');
            Utils.removeClass(shell, 'sticky-header-scroll');
        }
        super.disconnectedCallback();
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Number, emit: false })
], PacemStickyHeaderElement.prototype, "threshold", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Point })
], PacemStickyHeaderElement.prototype, "offset", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemStickyHeaderElement.prototype, "visible", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String, emit: false })
], PacemStickyHeaderElement.prototype, "visibility", void 0);
PacemStickyHeaderElement = __decorate([
    CustomElement({ tagName: P + '-sticky-header' })
], PacemStickyHeaderElement);
export { PacemStickyHeaderElement };
